module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteCloudAccountCopyButton.errorMessage":"There was an error encountered while deleting the shared cloud connection. If everything looks right please contact support so we can help you :)"}}')
  delete Component.options._Ctor
}
